import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      span: this.el.querySelector('span')
    };
    this.notificationBar = document.body.querySelector('.notification-bar--favorite');
    this.notificationBarHeading = this.notificationBar?.querySelector(
      '.notification-bar__heading'
    );
    this.notificationBarCopy = this.notificationBar?.querySelector(
      '.notification-bar__copy'
    );
    this.notificationBarDismissBtn = this.notificationBar?.querySelector(
      '.notification-bar__close-button'
    )

    this.loginModal = document.body.querySelector('.login-modal');
    this.favorited = this.el.dataset.favorited === 'false' ? false : true;
    this.favoriteLabel = this.el.dataset.favoriteLabel;
    this.favoritedLabel = this.el.dataset.favoritedLabel;
    this.dom.span.innerText = this.favorited
      ? this.favoritedLabel
      : this.favoriteLabel;

    this.updateNotificationBar();
  }

  addListeners() {
    this.el.addEventListener('click', this.handleFavoriteSubmit.bind(this));
    this.notificationBarDismissBtn.addEventListener('click', this.handleDismiss.bind(this));

    this.checkForClick();
  }

  checkForClick() {
    const queries = new URLSearchParams(window.location.search);
    if (queries.get('favorite')) {
      this.el.click();
      queries.delete('favorite');
      window.history.pushState({}, document.title, location.href.split('?')[0]);
    }
  }

  updateNotificationBar() {
    if (this.favorited) {
      this.notificationBarHeading.innerText = this.notificationBarHeading.dataset.removed;
      this.notificationBarCopy.innerText = this.notificationBarCopy.dataset.removed;
    } else {
      this.notificationBarHeading.innerText = this.notificationBarHeading.dataset.added;
      this.notificationBarCopy.innerText = this.notificationBarCopy.dataset.added;
    }
  }

  handleFavoriteSubmit() {
    if (this.notificationBar.classList.contains('notification-bar--show')) {
      this.handleDismiss();
    }
    const id = this.el.dataset.id
      ? this.el.dataset.id
      : document.head.querySelector('meta[property="page_id"').content;

    if (this.el.dataset.loggedIn === 'true') {
      this.el.classList.add('masthead__favorite-button--loading');
      const headers = {
        'content-type': 'application/json'
      };
      fetch(this.el.dataset.postEndpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify({ id, add: !this.favorited })
      })
        .then(r => r.json())
        .then(data => {
          if (data.Success) {
            this.notificationBar.classList.add('notification-bar--show');

            this.favorited = !this.favorited;
            this.dom.span.innerText = this.favorited
              ? this.favoritedLabel
              : this.favoriteLabel;
            this.el.setAttribute('data-favorited', this.favorited);
            this.el.dataset.favorited = this.favorited;
            this.timeout = setTimeout(() => {
              this.notificationBar.classList.remove('notification-bar--show');

              this.updateNotificationBar();
            }, parseInt(this.notificationBar.dataset.timeout));
          } else {
            this.loginModal.setAttribute('aria-hidden', false);
          }
        })
        .catch(console.error)
        .finally(() => {
          this.el.classList.remove('masthead__favorite-button--loading');
        });
    } else {
      this.loginModal.setAttribute('aria-hidden', false);
    }
  }

  handleDismiss() {
    clearTimeout(this.timeout);
    this.notificationBar.classList.remove('notification-bar--show');

    this.updateNotificationBar();
  }
}

export default Module;
